// extracted by mini-css-extract-plugin
export default {"pageContainer":"ExpensePage_pageContainer__O8owe"};